module.exports = __webpack_public_path__ + "img/tracking-logo.575c818c.png";